import { render } from "./LoadingSection.vue?vue&type=template&id=bcf482be&scoped=true"
import script from "./LoadingSection.vue?vue&type=script&lang=js"
export * from "./LoadingSection.vue?vue&type=script&lang=js"

import "./LoadingSection.vue?vue&type=style&index=0&id=bcf482be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcf482be"]])

export default __exports__